<template lang="pug">
  header.bg-white.min-h-72.d-flex
    .px-4.w-100.my-auto
      .row.align-items-center
        .col-auto
          el-button(@click='setMainMenuCollapse', type='text').py-0.text-secondary
            font-awesome-icon(:icon='["fal", isMainMenuCollapsed ? "bars" : "times"]').fs-18
        .col-auto
          h6(v-if="scopedCompany").text-primary.mb-0 {{ scopedCompany.name }}
          h4.mb-0 {{ pgTitle ? pgTitle : $route.meta.title }}

        //- .col-auto.ml-auto
        //-   el-button(type='text' circle icon='el-icon-message-solid').btn-outline

        .col-auto.pr-0.ml-auto
          .el-menu-in-header
            el-menu(v-bind='elMenuStyle', @select='handleSelectMenu')
              el-submenu(index='1').menu-item-profile
                template(slot='title')
                  .h-100
                    avatar(:imageUrl="profile.imageUrl").size-42.pin-y-center

                .px-20.py-3.text-center
                  .mb-2
                    avatar(:imageUrl="profile.imageUrl").size-100px.mx-auto
                  .fs-18.text-uppercase {{ profile.firstName }} {{ profile.lastName }}
                  .fs-14 {{ profile.email }}

                el-menu-item(index='/profile')
                  i(class='el-icon-user')
                  span(slot='title') Profile

                el-menu-item(@click='signOut')
                  i(class='el-icon-switch-button')
                  span(slot='title') Sign Out
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Avatar from '@/components/Avatar.vue';
import { AmplifyEventBus } from 'aws-amplify-vue';

export default {
  name: 'AppHeader',
  components: { Avatar },
  data() {
    return {
      elMenuStyle: {
        mode: 'horizontal',
        'background-color': '#fff',
        'text-color': '#393737',
        'active-text-color': '#0e9ecb',
      },
      profile: this.initProfile(),
    };
  },

  computed: {
    ...mapGetters('shared', ['pgTitle', 'isMainMenuCollapsed']),
    ...mapGetters('users', ['me', 'scopedCompany', 'isSuperAdmin']),
  },

  watch: {
    created() {
      console.log(this.getMe());
    },
    me(val) {
      if (val) {
        const { userRecord } = val;
        if (userRecord) {
          this.profile.firstName = userRecord.firstName;
          this.profile.lastName = userRecord.lastName;
          this.profile.email = userRecord.email;
        }
      }
    },
  },
  mounted() {
    console.log('profile header loaded');
    // this.addEvent();
    // this.profile = this.getProfileData();
  },

  methods: {
    ...mapActions('users', ['getMe']),
    ...mapActions('shared', ['setMainMenuCollapse']),

    initProfile() {
      console.log('....init profile ....');
      return {
        firstName: '',
        lastName: '',
        imageUrl: '',
        email: '',
      };
    },
    getProfileData() {
      const { userRecord } = this.me;
      console.log(this);
      return {
        firstName: userRecord.firstName,
        lastName: userRecord.lastName,
        imageUrl: userRecord.imageUrl,
        email: userRecord.email,
      };
    },
    handleSelectMenu(key) {
      // available perms: key, keyPath
      if (this.$route.path === key) return;
      if (key) this.$router.push(key);
    },
    signOut() {
      this.$Amplify.Auth.signOut()
        .then((data) => {
          console.log(data);
          return AmplifyEventBus.$emit('authState', 'signedOut');
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          // this.$router.push('/auth');
          console.log('done signing out');
        });
    },

    goToSignInPage() {
      localStorage.clear();
      this.$router.go();
    },
  },
};
</script>
